<template>
	<div>
		<section class="Contato bg-white">
			<div class="container">
				<h2 class="h2-contato">{{$t("contato.titulo")}}</h2>
				<form method="post" action="javascript:;">
					<div class="left-contato">
						<fieldset class="form-item validar">
							<input type="text" name="name" class="src" autocomplete="off" id="nome" value="" :placeholder="$t('contato.nome')">
							<span class="span-error">{{$t("contato.campo_obrigatorio")}}</span>
							
						</fieldset>

						<fieldset class="form-item validar">
							<input type="text" class="src" name="email" autocomplete="off" :placeholder="$t('contato.email')" id="email" value="">
							<span class="span-error">{{$t("contato.campo_obrigatorio")}}</span>
						</fieldset>

						<fieldset class="form-item">
							<input type="text" name="phone" v-mask="'(##) ####-#####'" autocomplete="off" :placeholder="$t('contato.telefone')" class="src" id="telefone" value="">
						</fieldset>

						<fieldset class="form-item">
							<input type="text" autocomplete="off" name="subject" :placeholder="$t('contato.assunto')" class="src" id="interest" value="">
						</fieldset>
					</div>

					<div class="right-contato">
						<fieldset class="form-item">
							<textarea class="src" name="message" :placeholder="$t('contato.mensagem')"></textarea>
						</fieldset>
					</div>

					<div class="actions">
						<fieldset class="button-contato">
							<div class="msg-success-error" v-if="success">{{$t("contato.successo")}}</div>
							<label v-if="display" id="text-right" class="text-right">Enviando ...</label>
							<router-link :to="{ name : 'contatosucesso'}" id="success"></router-link>
							<img src="/static/loading.gif" width="30" v-if="display">
							<input type="submit" :style="{ display: disable }" id="enviar" :value="$t('contato.enviar')" v-if="disable" @click="validate($event.target)">
						</fieldset>
					</div>
				</form>
			</div>
		</section>
	</div>
</template>

<script>
    import Vue from 'vue';
    import Home from '../../components/home/Home';
    import Message from '../shared/message/message';
    import VueTheMask from 'vue-the-mask';
    import {TheMask} from 'vue-the-mask';
    import {mask} from 'vue-the-mask';
    import contatoService from '../../domain/contactService'

    export default {

        components: {
            Home,
            Message,
            TheMask
        },

        directives: {mask},

        methods: {

            validate(target) {
                let inputs = target.closest("form").getElementsByClassName("src");

                this.obj = {};
                for( let a = 0; a < inputs.length; a++) {
                    let value = inputs[a].value !== "message" ? inputs[a].value : inputs[a].text;
                    let name = inputs[a].name;
                    if(inputs[a].parentNode.classList.contains('validar')){
                        if(value === "") {
                            inputs[a].parentNode.classList.add('error');
                        } else {
                            inputs[a].parentNode.classList.remove('error');
                            if(!this.validateEmail()){
                                document.getElementById("email").parentNode.classList.add('error');
                            }else{
                                document.getElementById("email").parentNode.classList.remove('error');
                            }
                        }
                    }
                    this.obj[name] = value
                }

                if(document.getElementsByClassName('error').length <= 0) {
                    this.display = true;
                    this.disable = "none";
                    this.success = false;
                    this.url = Vue.http.options.root+"/contact";

                    new contatoService(this.$http, this.url, this.obj, ( resp ) => {
                        if(resp.ok) {
                            target.closest("form").reset();
                            this.display = false;
                            this.disable = "inherit";
                            this.success = true;
                            this.$ga.event({
                                eventCategory: 'Formulário de contato',
                                eventAction: 'submit',
                                eventLabel: 'Enviar',
                                eventValue: 1
                            });
                            document.getElementById("success").click();
                        }
                    });

                }
            },

            validateEmail(){
                let email = document.getElementById("email").value;
                let filtro = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;

                return filtro.test(email);
            }

        },

        data() {
            return {
                titulo: "Contato",
                image: "/static/cases.png",
                display: false,
                disable: "block",
                success: false
            }
        },

        created() {
        }
    };

</script>

<style lang="scss">
	.Contato {
		padding: 60px 0;
		background: url("/static/contato.png") no-repeat center center;
		position: relative;
		background-size: cover;

		#success {
			display: none;
		}

		.container {
			padding: 60px 0;
		}

		.h2-contato {
			color: #ffffff;
			text-align: center;
			font-weight: normal;
			font-size: 3.4em;
			padding: 10px 0 20px 0;
		}

		form {
			margin: 0 auto;
			display: flex;
			flex-basis: 100%;
			flex-wrap: wrap;
			align-items: center;

			.actions {
				flex-basis: calc(100% - 24px);

				.msg-success-error {
					float: left;
					color: #1cfc7b;
					font-size: 18px;
					font-style: italic;
					margin-top: 25px;
				}
			}

			.left-contato {
				flex-basis: 49%;
			}

			.right-contato {
				flex-basis: 49%;
			}

			fieldset {
				width: 100%;
				margin-bottom: 10px;

				span {
					display: none;
				}

				&.error {
					text-align: left;

					span {
						width: 80%;
						color: red;
						display: block;
						text-align: left;
						font-size: 14px;
						font-style: italic;
						font-weight: normal;
					}
				}

				img {
					margin-right: 20px;
					margin-top: 15px;
				}

				label {
					width: 100px;
					display: block;
					float: left;
					margin-right: 20px;
					font-size: 18px;
					text-align: right;
					line-height: 40px;
					color: #ffffff;

					&.text-right {
						width: calc( 100% - 70px);
						margin-right: 20px;
						line-height: 60px;
					}
				}

				.msg-success {
					width: calc(100% - 290px);
					margin-right: 20px;
					line-height: 60px;
					float: left;
					border: 1px solid red;
					margin-left: 120px;
				}

				input {
					width: calc(100% - 140px);
					height: 40px;
					display: block;
					float: left;
					border: none;
					padding: 10px 0;
					background: none;
					border-bottom: 2px solid #cccccc;
					font-size: 16px;
					color: #cccccc;
					margin-bottom: 10px;

					&::placeholder {
						color: #cccccc;
					}
				}

				textarea {
					width: 100%;
					height: calc(210px - 20px);
					display: block;
					float: left;
					font-size: 16px;
					border-radius: 6px;
					padding: 10px;
					border: 2px solid #cccccc;
					background: none;
					color: #cccccc;
					margin-top: 30px;

					&::placeholder {
						color: #cccccc;
					}
				}

				&.button-contato {
					text-align: right;
					overflow: hidden;

					input {
						width: 120px;
						height: 50px;
						color: #ffffff;
						display: block;
						background: #3ab8e8;
						border-radius: 6px;
						font-size: 17px;
						float: right;
						margin: 10px 0 0 0;
						padding: 10px 0;
						font-weight: normal;
						border: 1px solid #3ab8e8;
					}
				}
			}
		}
	}

	@media (max-width: 767px) {
		.Contato {
			height: auto;

			form {
				width: 90%;
				margin: 0 auto;

				.left-contato {
					flex-basis: 100%;

					input {
						width: 100%;
					}
				}

				.right-contato {
					flex-basis: 100%;
				}
			}
		}
	}

	@media (max-width: 640px) {
		.Contato {
			height: auto;

			form {
				.left-contato {
					flex-basis: 100% !important;

					input {
						width: 100%;
					}
				}

				.right-contato {
					flex-basis: 100%;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/contato/Contato.vue